module.exports = "<canvas width=\"826\" height=\"1161\" id=\"ticketCanvas\" ng-init=\"$ctrl.init()\">\n</canvas>"


//////////////////
// WEBPACK FOOTER
// ./app/components/turnos/turnoOrderDeLlegada_Comprobante.html
// module id = 454
// module chunks = 0